import { Box, Container, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import "../../../components/ui/UploadImageModal/updateImages.css";
import { useGlobalContext } from "context/GlobalContext";
import FileContainerComp from "components/ui/UploadImageModal/FileContainerComp";
import TableContainerComp from "components/ui/UploadImageModal/TableContainerComp";
import Lottie from "lottie-react";
import SuccessAnimation from "../../../assets/icons/update_img_icons/success.json";
import { ReactComponent as Cross } from "../../../assets/icons/update_img_icons/cross.svg";
import apiClient from "lib/api-client";

const UpdateImagesPage = () => {
  const fileInputRef = useRef(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { showGifIcon, setShowGifIcon } = useGlobalContext();
  // const [dragging, setDragging] = useState(false);
  const [designStatus, setDesignStatus] = useState([]);

  const uploadAndCheckDesign = async (files) => {
    try {
      const styleNumber = files.map((file) => (file.updatedName ? file.updatedName : file.name.split(".").slice(0, -1).join(".")));

      const response = await apiClient.post("/api/v1/stylesImage/checkDesignNumber", { styleNumber, type: "Update_Images" });

      const data = response.data;

      const resultMap = data.reduce((acc, item) => {
        acc[item.styleNumber] = item.exists ? "Design Found" : "Design Not Found";
        return acc;
      }, {});

      const updatedSelectedFiles = files.map((file) => {
        const styleKey = file.updatedName || file.name.split(".").slice(0, -1).join(".");
        const existsStatus = resultMap[styleKey] === "Design Found"; // true or false

        file.exists = existsStatus;

        return file;
      });

      setSelectedFiles(updatedSelectedFiles);

      const updatedDesignStatus = files.map((file) => {
        const styleNumber = file.updatedName || file.name.split(".").slice(0, -1).join(".");
        const status = resultMap[styleNumber] || "Error Checking Design";

        return status;
      });

      setDesignStatus(updatedDesignStatus);
    } catch (error) {
      console.error("Error checking design:", error);
    }
  };

  // Function to trigger file selection
  // const handleContainerClick = () => {
  //   fileInputRef.current.click();
  // };

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);

    const validImages = [];

    files.forEach((file) => {
      const isImage = file.type.startsWith("image/");

      if(!isImage){
        alert("Only image files are allowed.");
      }

      if (isImage) {
        validImages.push(file);
      }
    });

    if (validImages.length > 0) {
      const updatedFiles = [...selectedFiles, ...validImages];
      setSelectedFiles(updatedFiles);
      await uploadAndCheckDesign(updatedFiles);
    }

    e.target.value = "";
  };

  // Function to handle file drop
  const handleDrop = async (e) => {
    e.preventDefault();
    // setDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const validImages = [];

    files.forEach((file) => {
      const isImage = file.type.startsWith("image/");

      if(!isImage){
        alert("Only image files are allowed.");
      }

      if (isImage) {
        validImages.push(file);
      }
    });

    if (validImages.length > 0) {
      const updatedFiles = [...selectedFiles, ...validImages];
      setSelectedFiles(updatedFiles);
      await uploadAndCheckDesign(updatedFiles);
    }
  };

  // Function to handle drag over
  // const handleDragOver = (e) => {
  //   e.preventDefault();
  //   setDragging(true);
  // };

  // Function to handle drag leave
  // const handleDragLeave = () => {
  //   setDragging(false);
  // };

  const handleDeleteImg = (indexToDelete) => {
    const updatedFiles = selectedFiles.filter((_, index) => index !== indexToDelete);
    setSelectedFiles(updatedFiles);

    const updatedDesignStatus = designStatus.filter((_, index) => index !== indexToDelete);
    setDesignStatus(updatedDesignStatus);
  };

  // const handleClear = () => {
  //   setSelectedFiles([]);
  // };

  const handleModalClose = () => {
    setShowGifIcon(false);
    // handleClear();
    setSelectedFiles([]);
  };

  const handleSubmitBtn = async () => {
    if (selectedFiles.length === 0) {
      alert("Please select at least one image before submitting.");
      return;
    }

    const formData = new FormData();

    selectedFiles.forEach((file) => {
      if (file.exists) {
        const newName = file.updatedName || file.name;
        const renamedFile = new File([file], newName.replace(/\.[^.]+$/, ".jpg"), {
          type: "image/jpeg",
        });

        formData.append("images", renamedFile);
      }
    });

    try {
      const response = await apiClient.post(`/api/v1/stylesImage/upload_Images?type=Update_Images`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status === 200) {
        setShowGifIcon(true);
        setSelectedFiles([]);
      } else {
        alert("Failed to upload. Please try again.");
      }
    } catch (error) {
      console.error("Upload error:", error);
      alert("An error occurred during upload.");
    }
  };

  return (
    <>
      <Container className="container" sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        {selectedFiles.length === 0 ? (
          <>
            <FileContainerComp 
              // handleDragOver={handleDragOver} 
              handleDrop={handleDrop}
              handleFileChange={handleFileChange} 
              // handleDragLeave={handleDragLeave} 
              // onclick={handleContainerClick} 
              // dragging={dragging} 
              fileheight={"543px"} 
            />
            {/* <input type="file" ref={fileInputRef} multiple accept="image/*" style={{ display: "none" }} onChange={handleFileChange} /> */}
          </>
        ) : (
          <>
            {selectedFiles.length > 0 && (
              <TableContainerComp
                selectedFiles={selectedFiles}
                setSelectedFiles={setSelectedFiles}
                // onclear={handleClear}
                handleFileChange={handleFileChange}
                // fileInputRef={fileInputRef}
                handleSubmitBtn={handleSubmitBtn}
                handleDeleteImg={handleDeleteImg}
                // handleDragOver={handleDragOver}
                handleDrop={handleDrop}
                // handleDragLeave={handleDragLeave}
                AddImagesBtn={true}
                uploadAndCheckDesign={uploadAndCheckDesign}
                designStatus={designStatus}
                // setDesignStatus={setDesignStatus}
                onClose={handleModalClose}
              />
            )}
          </>
        )}
      </Container>
      {showGifIcon && (
        <Box className="gifIcons">
          <Box sx={{ cursor: "pointer", position: "absolute", top: "32px", right: "32px" }} onClick={handleModalClose}>
            <Cross width={"20px"} height={"20px"} />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            {/* <img className='gifIconsImg' src={successGif} /> */}
            <Box className="gifIconsImg">
              <Lottie animationData={SuccessAnimation} />
            </Box>
            {/* <Typography className="gifIconsText">{`${selectedFiles.length} ${selectedFiles.length > 1 ? "Images have" : "Image has"} been uploaded successfully`}</Typography> */}
            <Typography className="gifIconsText">
              {`${designStatus.filter((status) => status === "Design Found").length} ${designStatus.filter((status) => status === "Design Found").length > 1 ? "Designs have" : "Design has"} been uploaded successfully`}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
};

export default UpdateImagesPage;
